"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlatName = exports.TrackingResponseStatus = exports.EventCategory = void 0;
var EventCategory;
(function (EventCategory) {
    EventCategory["BILLING"] = "BILLING";
    EventCategory["DASHBOARD"] = "DASHBOARD";
    EventCategory["EMAIL"] = "EMAIL";
    EventCategory["GOOGLEADS"] = "GOOGLEADS";
    EventCategory["JOB_CREATION"] = "JOB_CREATION";
    EventCategory["JOB_SETTINGS"] = "JOB_SETTINGS";
    EventCategory["JOB_SETTINGS_COPIED"] = "JOB_SETTINGS_COPIED";
    EventCategory["JOB_SETTINGS_PASTED"] = "JOB_SETTINGS_PASTED";
    EventCategory["JOIN_ORGANISATION"] = "JOIN_ORGANISATION";
    EventCategory["HOMEPAGE_CRAWL"] = "HOMEPAGE_CRAWL";
    EventCategory["LABELS"] = "LABELS";
    EventCategory["NAVIGATION"] = "NAVIGATION";
    EventCategory["PAYMENT"] = "PAYMENT";
    EventCategory["PLAN_RESTRICTION"] = "PLAN_RESTRICTION";
    EventCategory["PUBLIC_PAGE"] = "PUBLIC_PAGE";
    EventCategory["RUN_ALL"] = "RUN_ALL";
    EventCategory["SIGNUP"] = "SIGNUP";
    EventCategory["STANDALONE"] = "STANDALONE";
    EventCategory["TRIAL_UPGRADE"] = "TRIAL_UPGRADE";
    EventCategory["UPSELL"] = "UPSELL";
    EventCategory["USER_ADMIN"] = "USER_ADMIN";
    EventCategory["USER_PROFILE"] = "USER_PROFILE";
    EventCategory["WIDGET_LOAD"] = "WIDGET_LOAD";
    EventCategory["WIDGET_SIGNUP"] = "WIDGET_SIGNUP";
    EventCategory["WORKSPACE_VIEW"] = "WORKSPACE_VIEW";
    EventCategory["SUBSCRIPTION"] = "SUBSCRIPTION";
    EventCategory["TRIAL_END"] = "TRIAL_END";
    EventCategory["USER_SETTINGS"] = "USER_SETTINGS";
    EventCategory["PRICING"] = "PRICING";
})(EventCategory = exports.EventCategory || (exports.EventCategory = {}));
var TrackingResponseStatus;
(function (TrackingResponseStatus) {
    TrackingResponseStatus["SUCCESS"] = "Success";
    TrackingResponseStatus["ERROR"] = "Error";
})(TrackingResponseStatus = exports.TrackingResponseStatus || (exports.TrackingResponseStatus = {}));
function getFlatName(event) {
    return event.category + "_" + event.name;
}
exports.getFlatName = getFlatName;
//# sourceMappingURL=Target.js.map